module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "header-box add-bg"
  }, [_c('div', {
    staticClass: "c-header"
  }, [_vm._m(0), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: index == _vm.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.goUrl(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('h2', [_vm._v("职位列表")]), _vm._m(1), _c('div', {
    staticClass: "search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入关键词搜索更多职位，例如“工程师”"
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }
    }
  }), _c('span', {
    on: {
      "click": _vm.searchHandler
    }
  }, [_vm._v("搜索")])]), _c('div', {
    staticClass: "selects"
  }, [_c('el-select', {
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "placeholder": "请选择工作地点"
    },
    model: {
      value: (_vm.workPlace),
      callback: function($$v) {
        _vm.workPlace = $$v
      },
      expression: "workPlace"
    }
  }, _vm._l((_vm.workPlaceList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _c('span', {
    staticStyle: {
      "width": "4%",
      "display": "inline-block"
    }
  }), _c('el-select', {
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "placeholder": "请选择职位类型"
    },
    model: {
      value: (_vm.position),
      callback: function($$v) {
        _vm.position = $$v
      },
      expression: "position"
    }
  }, _vm._l((_vm.positionList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _c('div', {
    staticClass: "job-list"
  }, [(_vm.jobList.length > 0) ? _c('ul', _vm._l((_vm.jobList), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.goDetail(item.positionName)
        }
      }
    }, [_c('p', {
      staticClass: "job-item"
    }, [_c('span', [_vm._v(_vm._s(item.positionName))]), _c('i', [_vm._v("发布时间：" + _vm._s(item.releaseDate))])])])
  }), 0) : _c('div', {
    staticClass: "no-job"
  }, [_vm._v("暂无招聘信息")]), (_vm.totalRecord > 0 && _vm.jobList.length > 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": [10, 20, 30],
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next",
      "total": _vm.totalRecord
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.pageIndex = $event
      },
      "update:current-page": function($event) {
        _vm.pageIndex = $event
      }
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/header-logo-orange-xd.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("简历发送至:"), _c('span', [_vm._v("jrzp@bajiegroup.com")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-26cc9c55", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26cc9c55","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/joinUs.vue
// module id = 1188
// module chunks = 2